import tinycolor from 'tinycolor2';

export default function textColor(color) {
	const readWhite = tinycolor.readability(color, '#fff');
	const readBlack = tinycolor.readability(color, '#000');

	return readWhite > readBlack ? 'white' : 'black';
}
